/**
 * The style of the font.
 */
export enum FontStyle {
  /** Set font without style */
  None = 0x0,
  /** Set font bold */
  Bold = 0x1,
  /** Set font italic */
  Italic = 0x2
}
